var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowpagination(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.191815 5.46625L4.52543 9.79997C4.64914 9.92367 4.81402 9.99158 4.98982 9.99158C5.16582 9.99158 5.3306 9.92358 5.4543 9.79997L5.84776 9.40641C5.97137 9.2829 6.03947 9.11793 6.03947 8.94202C6.03947 8.76622 5.97137 8.59569 5.84776 8.47217L3.31959 5.93844L11.3517 5.93844C11.7139 5.93844 12 5.65493 12 5.29269L12 4.7363C12 4.37406 11.7139 4.06197 11.3517 4.06197L3.29091 4.06197L5.84767 1.51408C5.97128 1.39038 6.03937 1.22989 6.03937 1.05399C6.03937 0.878285 5.97128 0.715457 5.84767 0.591848L5.45421 0.199559C5.3305 0.0758527 5.16572 0.00843868 4.98972 0.00843867C4.81392 0.00843865 4.64904 0.0767302 4.52534 0.200437L0.191718 4.53406C0.0677188 4.65816 -0.000475354 4.82381 1.24311e-05 4.99991C-0.000377825 5.17659 0.0677187 5.34235 0.191815 5.46625Z",
    fill: "#0D263B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowpagination);
export default __webpack_public_path__ + "static/media/arrowpagination.2fb4fa19613e9666dac0b1c432ec105b.svg";
export { ForwardRef as ReactComponent };